<template>

  <div id="app">
    <router-view v-wechat-title="$route.meta.title" />
  </div>
</template>

<script>
  import Vue from 'vue'
  import Element from 'element-ui'
  import 'element-ui/lib/theme-chalk/index.css'
  // import MenuList from './components/menu.vue'
  // import Header from './components/head.vue'
  // import MetaInfo from 'vue-meta-info'  //SEO

  Vue.use(Element)
  // Vue.use(MenuList)
  // Vue.use(Header)

  // Vue.use(MetaInfo) //SEO

  export default {
    name: 'app',
    data: function() {
      return {
        active: true
      }
    },
    methods: {
      getRequestParams() {
        let url = location.href
        let requestParams = {}
        if (url.indexOf('?') !== -1) {
          let str = url.substr(url.indexOf('?') + 1) // 截取?后面的内容作为字符串
          console.log(str, '?后面的内容')
          let strs = str.split('&') // 将字符串内容以&分隔为一个数组
          console.log(strs, '以&切割的数组')
          for (let i = 0; i < strs.length; i++) {
            requestParams[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
            // 将数组元素中'='左边的内容作为对象的属性名，'='右边的内容作为对象对应属性的属性值
          }
        }
        // console.log(requestParams, '处理后的对象')
        return requestParams
      }
    },
    mounted() {
      // const script = document.createElement('script')
      // script.src = 'https://s4.cnzz.com/z_stat.php?id=1279532325&web_id=1279532325'
      // script.language = 'JavaScript'
      // document.body.appendChild(script)

      // // seo优化使用
      // document.dispatchEvent(new Event('render-event'))

      // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      //   window.addEventListener('hashchange', () => {
      //     let currentPath = window.location.hash.slice(1)

      //     if (this.$route.path !== currentPath) {
      //       this.$router.push(currentPath)
      //     }
      //   }, false)
      // }

      // console.log(form_id, form_id)
      var url = location.href
      console.log('location.href', location.href)

      if (url.indexOf('user_form') > 0) {
        let params = this.getRequestParams()
        let form_id = params['form_id']
        form_id = form_id.replace('#/', '')

        form_id = form_id.substring(form_id.indexOf('='))
        form_id = form_id.trim()

        this.$router.push({
          name: 'user_form',
          params: {
            // form_id: form_id
            form_id: form_id
          }
        })
      }
    },
    watch: {
      '$route'() {
        // if (window._czc) {
        //   let location = window.location
        //   let contentUrl = location.pathname + location.hash
        //   let refererUrl = '/'
        //   window._czc.push(['_trackPageview', contentUrl, refererUrl])
        // }
      }
    }
  }
</script>

<style>
  body {
    margin: 0;
  }

  #app {
    min-width: 1200px;
    margin: 0 auto;
    font-family: "Helvetica Neue", "PingFang SC", Arial, sans-serif;
  }

  /* 头部导航 */
  header {
    z-index: 1000;
    min-width: 1200px;
    transition: all 0.5s ease;
    border-top: solid 4px #3091F2;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
  }

  header.header-fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }

  header .el-menu-demo {
    padding-left: 300px !important;
  }

  /* 主内容区 */
  main {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    min-height: 800px;
    border: solid 40px #E9ECF1;
    background-color: #FCFCFC;
  }

  main .main-left {
    text-align: center;
    width: 200px;
    float: left;
  }

  main .main-right {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    background-color: #fff;
    padding: 50px 70px;
  }

  main .el-menu {
    background-color: transparent !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue